var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVendorChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 57,
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.654785,
    width: 47,
    height: 55,
    rx: 7.5,
    stroke: "#D9F0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3255 17.0976C13.0991 17.2129 12.6421 17.355 11.9642 17.355C10.087 17.355 9.00977 16.0067 9.00977 14.2864C9.00977 12.2385 10.3824 11.1548 12.0888 11.1548C12.7504 11.1548 13.0999 11.287 13.3251 11.4119L13.1166 12.6367C12.8659 12.5207 12.5999 12.4152 12.1404 12.4152C11.3277 12.4152 10.4657 12.9199 10.4657 14.2638C10.4657 15.466 11.1531 16.1019 12.1472 16.1019C12.541 16.1019 12.8082 16.0212 13.1166 15.8734L13.3255 17.0976Z",
    fill: "#0056A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4417 12.6736C15.936 12.6736 15.4467 12.913 15.1975 13.2976H15.1822V11.1763L13.9102 11.6362V17.1706H15.1822V14.5854C15.1822 14.2121 15.4146 13.8106 15.8602 13.8106C16.337 13.8106 16.5207 14.2025 16.5207 14.7727V17.1707H17.7938V14.5893C17.7938 13.2715 17.2526 12.6736 16.4417 12.6736Z",
    fill: "#0056A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8934 16.2894C20.2054 16.283 19.7602 15.9852 19.7134 15.4246H22.4814C22.4959 15.3225 22.5121 15.0997 22.5121 14.9629C22.5121 13.6645 21.908 12.6282 20.5602 12.6282C19.2525 12.6282 18.3799 13.5376 18.3799 14.947C18.3799 16.4039 19.1914 17.3549 20.7056 17.3549C21.2676 17.3549 21.8197 17.2567 22.303 17.0032L22.1111 15.9693C21.79 16.1669 21.308 16.2928 20.8934 16.2894ZM20.5006 13.5842C21.0895 13.5842 21.2416 14.1535 21.2416 14.4791H19.7046C19.7407 14.0484 19.9842 13.5842 20.5006 13.5842Z",
    fill: "#0056A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0071 17.1704L22.6016 12.813H24.005L24.7685 15.8953H24.7942L25.5579 12.813H26.9618L25.5564 17.1704H24.0071Z",
    fill: "#0056A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3228 14.246C27.3228 13.605 27.3035 13.1868 27.2773 12.8129H28.4757L28.512 13.6229H28.5442C28.7539 12.9818 29.1564 12.7383 29.5704 12.7137C29.7672 12.7018 29.8737 12.7163 29.9955 12.7409V14.015C29.8789 13.9912 29.6475 13.9631 29.4849 13.9787C28.9953 14.0258 28.6991 14.3976 28.616 14.8257C28.5993 14.9144 28.5906 15.0129 28.5906 15.1281V17.1703H27.3232V14.246H27.3228Z",
    fill: "#0056A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3064 17.3549C33.6415 17.3549 34.4655 16.4197 34.4655 14.9916C34.4655 13.5634 33.6415 12.6282 32.3064 12.6282C30.971 12.6282 30.1465 13.5633 30.1465 14.9916C30.1465 16.4197 30.971 17.3549 32.3064 17.3549ZM32.3067 13.6655C32.9136 13.6655 33.147 14.2827 33.147 14.9918C33.147 15.7015 32.9138 16.3178 32.3067 16.3178C31.699 16.3178 31.4668 15.7015 31.4668 14.9918C31.4668 14.2826 31.699 13.6655 32.3067 13.6655Z",
    fill: "#0056A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0303 14.2019C35.0303 13.6581 35.0113 13.1938 34.9844 12.8127H36.1827L36.2102 13.4223H36.2358C36.4018 13.1388 36.841 12.6731 37.5262 12.6731C38.3648 12.6731 38.9123 13.271 38.9123 14.5537V17.1702H37.6413V14.754C37.6413 14.1933 37.4571 13.81 36.9972 13.81C36.6446 13.81 36.4256 14.0689 36.3443 14.3172C36.3142 14.4081 36.3019 14.5316 36.3019 14.6564V17.1701H35.0303V14.2019Z",
    fill: "#0056A2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28.3886V18.3286L23.7692 23.3589L9 28.3886Z",
    fill: "url(#paint0_linear_1419_59497)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28.5483L24.0004 33.6582L39 28.5483V18.3286L24.0004 23.4378L9 28.5483Z",
    fill: "url(#paint1_linear_1419_59497)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00127 39.8847L9 29.8247L23.7692 34.8531L9.00127 39.8847Z",
    fill: "url(#paint2_linear_1419_59497)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39 29.8247L23.9964 34.9321L9 40.0442L23.9993 45.1543L39 40.0426V29.8247Z",
    fill: "url(#paint3_linear_1419_59497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1419_59497",
    x1: 40.393,
    y1: 18.3286,
    x2: 32.8766,
    y2: -6.51241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06549B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2FA1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2FA1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1419_59497",
    x1: 90.0035,
    y1: 39.7903,
    x2: 98.0334,
    y2: -45.0718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1371B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2FA1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2FA1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#06569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1419_59497",
    x1: 33.7357,
    y1: 29.8247,
    x2: 25.2762,
    y2: 13.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D1A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9D1A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E6192F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1419_59497",
    x1: 89.9801,
    y1: 51.2846,
    x2: 98.0101,
    y2: -33.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A21C38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E6192F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E6192F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A71C37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVendorChevron);
export default __webpack_public_path__ + "static/media/ic-vendor-chevron.e9298f0775627481f73206896c7409e4.svg";
export { ForwardRef as ReactComponent };